import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ObservableStore } from '@codewithdan/observable-store';
import { LicenseManager } from '@ag-grid-enterprise/all-modules';
import { enableDebugTools } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
  overrideConsole();
  (LicenseManager as any).prototype.outputMissingLicenseKey = () => {};
} else {
  // :^)
  (LicenseManager as any).prototype.outputMissingLicenseKey = () => {};
}

enableProdMode();

// Set ObservableStore globalSettings here since
// it'll be called before the rest of the app loads
ObservableStore.globalSettings = {
  isProduction: false,
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(moduleRef => {
    const applicationRef = moduleRef.injector.get(ApplicationRef);
    const componentRef = applicationRef.components[0];
    // allows to run `ng.profiler.timeChangeDetection();`
    enableDebugTools(componentRef);
  })
  .catch(err => console.error(err));

function overrideConsole() {
  (window as any).console.log = () => {};
  (window as any).console.warn  = () =>  {};
  (window as any).console.info  = () =>  {};
}
